// serialize
// @AUTHOR CAIHUAZHI <huazhi.chz@alibaba-inc.com>
// @CREATE 2023/08/24 12:16
import { isEmpty } from './common';
/**
 * JSON 序列化
 * @param params
 * @param options.holdEmpty 是否保留字符串，默认 false
 * @param options.listHandler 数组处理方式, 默认 `JOIN`
 * - `REPEAT`: 重复 `a=1&a=2`
 * - `JOIN`: 用逗号连接 `a=1,2`
 * - `STRINGIFY`：用 JSON.stringify 处理
 */
export const serialize = (params, options) => {
    if (!params)
        return '';
    if (typeof params === 'string')
        return params;
    const { holdEmpty = false, listHandler = 'JOIN' } = options || {};
    const sp = new URLSearchParams();
    Object.keys(params).forEach((key) => {
        const value = params[key];
        if (value === '' && holdEmpty) {
            return sp.set(key, '');
        }
        if (isEmpty(value))
            return;
        if (!Array.isArray(value)) {
            const valueStr = typeof value === 'object' ? JSON.stringify(value) : value;
            return sp.set(key, valueStr);
        }
        switch (listHandler) {
            case 'REPEAT':
                return value.forEach((v) => sp.append(key, v));
            case 'STRINGIFY':
                return sp.set(key, JSON.stringify(value));
            default: // JOIN
                return sp.set(key, value.join(','));
        }
    });
    return sp.toString();
};
